import React from 'react'
import { Link } from 'react-router-dom'

function BackButton() {
    return (
        <Link className='btn btn-outline-secondary btn-app' to={-1}>
            <i className='bi bi-arrow-left' aria-hidden="true"></i>
            <span>Geri</span>
        </Link>
    )
}

export default BackButton